import type {
	GraphQLContentStatus,
	CommentType,
} from '../__generated__/ActiveCommentsQuery.graphql.ts';

export const ACTIVE_COMMENTS_QUERY_PRELOAD_COUNT = 3;
export const ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG = -1; // We can't do cache.evict based on apollo version, so use -1 as a flag

export const ACTIVE_COMMENTS_QUERY_DEFAULT_LOAD_COUNT = 2000;

export const buildConsistentActiveCommentsQueryPreloadVariables = (
	contentId: string,
	isArchived?: boolean,
): {
	pageId: string;
	contentStatus: GraphQLContentStatus[];
	type: CommentType[];
	first: number;
} => {
	return {
		pageId: contentId,
		contentStatus: [isArchived ? 'ARCHIVED' : 'CURRENT', 'DRAFT'] as GraphQLContentStatus[],
		type: ['FOOTER'] as CommentType[],
		first: ACTIVE_COMMENTS_QUERY_PRELOAD_COUNT,
	};
};

export const buildConsistentActiveCommentsQueryVariables = ({
	pageId,
	type,
	isArchived = false,
}: {
	pageId: string;
	type?: CommentType | null;
	isArchived?: boolean;
}): {
	type?: CommentType[] | undefined;
	pageId: string;
	contentStatus: GraphQLContentStatus[];
	first: number;
} => {
	return {
		pageId,
		contentStatus: [isArchived ? 'ARCHIVED' : 'CURRENT', 'DRAFT'] as GraphQLContentStatus[],
		first: ACTIVE_COMMENTS_QUERY_DEFAULT_LOAD_COUNT,
		...(type && { type: [type] }),
	};
};
